import { getEnvironmentConfig, httpClientInterface } from 'app-components/utils/core';
import AxiosFactory from 'utils/axiosFactory';

const qcsAxios = AxiosFactory.get('qcs');

// implement shared interfaces
httpClientInterface.httpClientInterfaceInit({
  getServiceUrl: () => getEnvironmentConfig()?.services_url,
  getAxios: () => qcsAxios,
  send: (method, url, data, headers, params, properties) => {
    let promise;
    switch (method) {
      case 'GET':
        promise = qcsAxios.get(url, { ...properties, headers, params });
        break;
      case 'POST':
        promise = qcsAxios.post(url, data, { ...properties, headers, params });
        break;
      case 'PUT':
        promise = qcsAxios.put(url, data, { ...properties, headers, params });
        break;
      case 'DELETE':
        promise = qcsAxios.delete(url, { ...properties, headers, params });
        break;
      case 'PATCH':
        promise = qcsAxios.patch(url, data, { ...properties, headers, params });
        break;
      case 'OPTIONS':
        promise = qcsAxios.options(url, { ...properties, headers, params });
        break;
      default:
      // TODO: assert
    }
    return promise;
  },
});
